import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SidebarService {

  private expanded = new BehaviorSubject<boolean>(true);
  private visible = new BehaviorSubject<boolean>(true);

  constructor() {}

  toggle(): void {
    this.expanded.next(!this.expanded.value);
  }

  setExpanded(value: boolean): void {
    this.expanded.next(value);
  }

  setVisible(value: boolean): void {
    this.visible.next(value);
  }

  subscribeToEvent(callback: (data: boolean) => void): void {
    this.expanded.subscribe(callback);
  }

  subscribeToHide(callback: (data: boolean) => void): void {
    this.visible.subscribe(callback);
  }

  get isExpanded(): Observable<boolean> {
    return this.expanded.asObservable();
  }

  get isVisible(): Observable<boolean> {
    return this.visible.asObservable();
  }
}
